import React, { useState, useEffect } from "react"
import { Dropdown, NavLink, NavItem } from "react-bootstrap"
import ActiveLink from "./../ActiveLink"
import { LogOut } from "lucide-react"
import userMenu from "../../data/user-menu.json"
import Avatar from "../Avatar"

export default function UserMenu({ onLinkClick, user }) {
  const [userCompany, setUserCompany] = useState(null)

  useEffect(() => {
    if (user && user.user_id) {
      fetch(`/api/user/company?id=${user.user_id}`)
        .then((res) => {
          if (!res.ok) throw new Error("Failed to fetch user company")
          return res.json()
        })
        .then((data) => {
          if (data && data.length > 0) {
            setUserCompany(data[0])
          }
        })
        .catch((err) => {
          console.error("Error fetching user company in UserMenu:", err)
        })
    }
  }, [user])

  const userAlt =
    user?.name && !user.name.includes("@")
      ? user.name
      : user?.nickname || "Profile"

  const hasSocialAvatar = Boolean(
    user &&
      (user.sub?.startsWith("google-oauth2|") ||
        user.sub?.startsWith("linkedin|") ||
        user.picture?.includes("googleusercontent.com") ||
        user.picture?.includes("licdn.com"))
  )
  const avatarImage =
    hasSocialAvatar && user?.picture ? user.picture : "/favicon.png"
  const isDefaultAvatar = !hasSocialAvatar || !user?.picture

  return (
    <Dropdown
      as={NavItem}
      className={userMenu.type === "avatar" ? "ms-lg-3" : ""}
    >
      <Dropdown.Toggle
        as={NavLink}
        style={userMenu.type === "avatar" && { padding: 0 }}
        className="dropdown-avatar"
      >
        {userMenu.type === "avatar" ? (
          <Avatar
            image={avatarImage}
            alt={userAlt}
            className={`me-2 avatar-border-white ${
              isDefaultAvatar ? "avatar-grayscale" : ""
            }`}
            size="sm"
            cover
          />
        ) : (
          userMenu.title
        )}
      </Dropdown.Toggle>
      <Dropdown.Menu align="end">
        {userMenu.dropdown &&
          userMenu.dropdown.map((dropdownItem, index) => {
            if (dropdownItem.divider) {
              return <Dropdown.Divider key={index} />
            }
            if (dropdownItem.signout) {
              return (
                <Dropdown.Item key={index} href={dropdownItem.link}>
                  <LogOut
                    className="me-2 text-muted d-inline-block align-middle"
                    size={16}
                  />
                  {dropdownItem.title}
                </Dropdown.Item>
              )
            }

            let title = dropdownItem.title
            let link = dropdownItem.link

            if (dropdownItem.link === "/user-form/add" && userCompany) {
              title = "Edit Company"
              link = `/user-form/${userCompany.company_id}/company`
            }

            return (!dropdownItem.isAdmin || dropdownItem.isAdmin === user.is_admin) ? (
              <ActiveLink
                key={index}
                activeClassName="active"
                href={link}
                passHref
                legacyBehavior
              >
                <Dropdown.Item onClick={() => onLinkClick(userMenu.title)}>
                  {title}
                </Dropdown.Item>
              </ActiveLink>
            ) : null
          })}
      </Dropdown.Menu>
    </Dropdown>
  )
}
